import styled, { css } from 'styled-components';
import { ModalHeader, ModalSubHeaderStyled, ModalBody } from '@bechtel/gds';

export const ModalSubHeader = styled(ModalSubHeaderStyled)`
  ${({ theme }) => css`
    padding: ${theme.spacings[550]} ${theme.spacings[500]};
  `}
`;

export const ModalHeaderStyled = styled(ModalHeader)`
  background: ${({ theme }) => theme.colors.bechtel.blue[800]};

  h1 {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }
  button {
    background: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.bechtel.blue[800]};
    }
  }
`;

export const Table = styled('table')`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[700]};
    text-align: left;
  `};
`;

export const TableHeading = styled('th')`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[700]};
    padding-bottom: ${theme.spacings[300]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
  `};
`;
export const TableCol = styled('td')`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[200]};
    padding-bottom: ${theme.spacings[200]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
  `};
`;

export const ModalBodyStyled = styled(ModalBody)`
  flex-direction: column;
`;
